export const LocationIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.2 22.4C6.29315 22.2758 6.41393 22.175 6.55279 22.1056C6.69164 22.0361 6.84476 22 7 22H12C12.2652 22 12.5196 22.1054 12.7071 22.2929C12.8946 22.4804 13 22.7348 13 23C13 23.2652 12.8946 23.5196 12.7071 23.7071C12.5196 23.8946 12.2652 24 12 24H7.5L3 30H29L24.5 24H20C19.7348 24 19.4804 23.8946 19.2929 23.7071C19.1054 23.5196 19 23.2652 19 23C19 22.7348 19.1054 22.4804 19.2929 22.2929C19.4804 22.1054 19.7348 22 20 22H25C25.1552 22 25.3084 22.0361 25.4472 22.1056C25.5861 22.175 25.7069 22.2758 25.8 22.4L31.8 30.4C31.9114 30.5486 31.9793 30.7252 31.996 30.9102C32.0126 31.0952 31.9775 31.2811 31.8944 31.4472C31.8114 31.6133 31.6837 31.753 31.5257 31.8507C31.3678 31.9483 31.1857 32 31 32H1C0.814289 32 0.632245 31.9483 0.474269 31.8507C0.316293 31.753 0.188626 31.6133 0.105573 31.4472C0.0225204 31.2811 -0.0126368 31.0952 0.00404116 30.9102C0.0207191 30.7252 0.0885733 30.5486 0.2 30.4L6.2 22.4Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 7.99981C8.00014 6.46026 8.44451 4.95345 9.27979 3.66019C10.1151 2.36693 11.3058 1.34215 12.709 0.708821C14.1123 0.075491 15.6684 -0.139488 17.1908 0.0896813C18.7132 0.31885 20.1372 0.982432 21.2918 2.0008C22.4464 3.01917 23.2826 4.34907 23.7002 5.83092C24.1177 7.31276 24.0988 8.88362 23.6457 10.355C23.1926 11.8263 22.3246 13.1357 21.1458 14.126C19.967 15.1163 18.5275 15.7454 17 15.9378V26.9998C17 27.265 16.8946 27.5194 16.7071 27.7069C16.5196 27.8945 16.2652 27.9998 16 27.9998C15.7348 27.9998 15.4804 27.8945 15.2929 27.7069C15.1054 27.5194 15 27.265 15 26.9998V15.9398C13.0659 15.6961 11.2874 14.7547 9.99843 13.2923C8.70948 11.8299 7.99884 9.94917 8 7.99981Z"
        fill="white"
      />
    </svg>
  );
};
